import React, { useState, useEffect } from 'react';
import { Checkbox } from 'antd';
import { Carousel } from 'antd';
import screenshot1 from '../../assets/images/1.PNG';
import screenshot2 from '../../assets/images/2.PNG';
import screenshot3 from '../../assets/images/3.PNG';
import taylorDark1 from '../../assets/images/dark1.png';
import taylorDark2 from '../../assets/images/dark2.png';
import taylorLight1 from '../../assets/images/light1.png';
import taylorLight2 from '../../assets/images/light2.png';
import taylorLight3 from '../../assets/images/light3.png';

const taylorImages = [taylorLight1, taylorDark1, taylorLight2, taylorDark2, taylorLight3];

const items = [
  {
    key: '1',
    title: 'Web and mobile applications built for everyone',
    content:
      `No matter your industry, impressive website design is important in today's digital age. If you're looking to take your business to the next level, you need a custom web design to help you attract and convert more customers. At DESI8N we deliver stunning, responsive designs that are created with conversion in mind.`,
  },
  {
    key: '2',
    title: 'Work together',
    content:
      `At DESI8N, we have a specific process that allows us to provide our clients with the best possible results from their websites. When you partner with us, our designers will work to deliver a website that reflects your brand, sets you apart from your competitors, and helps you reach your company's goals. We use multiple steps to learn about your company and create a site that matches your goals and increases conversions.`,
  },
  {
    key: '3',
    title: 'The best app to increase your productivity',
    content:
      'Our web design packages uses cutting-edge web design technology to deliver an experience your users will love. Our web designers build every website with your customers point of view in mind. We know that it only takes 5 seconds for users to decide whether or not to trust a website. And, that your web design is the deciding factor. Our web designers will assess your business, your customers, and develop a design that delivers results.',
  },
];

function AppHero() {
  const [showTaylor, setShowTaylor] = useState(false);
  const [taylorIdx, setTaylorIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setShowTaylor(prev => {
        if (!prev) setTaylorIdx(i => (i + 1) % taylorImages.length);
        return !prev;
      });
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div id='hero' className='heroBlock'>
      <div className='container-fluid'>
        <div className='hero-inner'>
          <div className='hero-carousel'>
            <Carousel autoplay>
              {items.map((item) => (
                <div key={item.key}>
                  <div className='content'>
                    <h3>{item.title}</h3>
                    <p>{item.content}</p>
                    <div className='btnHolder'>
                      <a className='ant-btn ant-btn-primary' href='#works'>
                        <i className='fas fa-info'></i> Learn More
                      </a>{' '}
                      <a className='ant-btn ant-btn' href='#contact'>
                        <i className='fas fa-desktop'></i> Get in Touch
                      </a>
                    </div>
                    <div style={{ height: '32px' }} />
                    <Checkbox checked>No startup costs, no upfront investment.</Checkbox>
                    <Checkbox checked style={{ marginLeft: '-1px' }}>You pay nothing if you don't love your website.</Checkbox>
                    <Checkbox checked style={{ marginLeft: '-1px' }}>No credit card required to get started.</Checkbox>
                    <Checkbox checked style={{ marginLeft: '-1px' }}>Every service is backed by our 30 day money-back guarantee.</Checkbox>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
          <div className='hero-screenshots-wrapper'>
            <div className={`hero-screenshots hero-mobile-group${showTaylor ? ' hero-group-hidden' : ''}`}>
              <img src={screenshot1} alt='QuickShift dashboard' className='hero-screenshot hero-screenshot--1' />
              <img src={screenshot2} alt='QuickShift timer' className='hero-screenshot hero-screenshot--2' />
              <img src={screenshot3} alt='QuickShift dark mode' className='hero-screenshot hero-screenshot--3' />
            </div>
            <div className={`hero-taylor-group${showTaylor ? '' : ' hero-group-hidden'}`}>
              <div className='hero-taylor-slideshow'>
                {taylorImages.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt='Taylor'
                    className={`hero-screenshot hero-screenshot--taylor${i === taylorIdx ? ' hero-taylor-active' : ''}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppHero;
